import React, { useState, useRef, useEffect } from "react";
import { classNames } from "primereact/utils";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import axios from "axios";
import DashSideBar from "../../shared/DashSideBar";
import "./ProductListContent.css";
import { Editor } from "primereact/editor";
import { Dropdown } from "primereact/dropdown";

function ProductListContents() {
  let emptyProductListContent = {
    id: null,
    description: "",
    sortOrder: null,
    product: { id: null, name: "" },
  };
  const [ProductListContents, setProductListContents] = useState(null);
  const [products, setProducts] = useState(null);
  const [ProductListContentsDialog, setProductListContentsDialog] =
    useState(false);
  const [DeleteProductListContent, setDeleteProductListContent] =
    useState(false);
  const [DeleteProductListContentsDialog, setDeleteProductListContentsDialog] =
    useState(false);
  const [ProductListContent, setProductListContent] = useState(
    emptyProductListContent
  );
  const [selectedProductListContents, setSelectedProductListContents] =
    useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [loading, setLoading] = useState(false);
  const toast = useRef(null);
  const dt = useRef(null);

  const isFetched = useRef(false);

  useEffect(() => {
    if (!isFetched.current) {
      getProductListContents();
      getProducts();
      isFetched.current = true; // Ensure it only runs once
    }
  }, []);
  const getProducts = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_URL + "api/Products/ProductNameResponse"
      );

      if (response.data) {
        setProducts(response.data);
      }
    } catch (error) {
      console.error("Error fetching products: ", error);
    }
  };
  const getProductListContents = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_URL +
          "api/ProductListContents/ProductListContentResponse"
      );

      if (response.data) {
        setProductListContents(response.data);
      }
    } catch (error) {
      console.error("Error fetching Product List Contents:", error);
    }
  };

  const openNew = () => {
    setProductListContent(emptyProductListContent);
    setSubmitted(false);
    setProductListContentsDialog(true);
  };

  const hideDialog = () => {
    setSubmitted(false);
    setProductListContentsDialog(false);
  };

  const hideDeleteProductDialog = () => {
    setDeleteProductListContent(false);
  };

  const hideDeleteProductsDialog = () => {
    setDeleteProductListContentsDialog(false);
  };

  const saveService = async () => {
    setLoading(true);
    setSubmitted(true);

    try {
      let _ProductListContents = [...ProductListContents];
      let _ProductListContent = { ...ProductListContent };

      if (ProductListContent.id) {
        const index = findIndexById(ProductListContent.id);

        const payload = {
          Description: _ProductListContent.description,
          SortOrder: isNaN(parseInt(_ProductListContent.sortOrder))
            ? 1
            : parseInt(_ProductListContent.sortOrder),
          ProductId: _ProductListContent.product.id,
        };

        const response = await axios.put(
          process.env.REACT_APP_BACKEND_URL +
            "api/ProductListContents/" +
            ProductListContent.id,
          payload,
          {
            headers: {
              "Content-Type": "application/json", // ✅ Proper for JSON body
            },
          }
        );

        if (response.data) {
          _ProductListContents[index] = _ProductListContent;
          toast.current.show({
            severity: "success",
            summary: "Successful",
            detail: "Our Product List Content Updated",
            life: 3000,
          });
        } else {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: "Our Product List Content Not Updated",
            life: 3000,
          });
        }
      } else {
        _ProductListContent.id = createId();
        const payload = {
          Description: _ProductListContent.description,
          SortOrder: isNaN(parseInt(_ProductListContent.sortOrder))
            ? 1
            : parseInt(_ProductListContent.sortOrder),
          ProductId: _ProductListContent.product.id,
        };

        const response = await axios.post(
          process.env.REACT_APP_BACKEND_URL + "api/ProductListContents",
          payload,
          {
            headers: {
              "Content-Type": "application/json", // ✅ Proper for JSON body
            },
          }
        );

        if (response.data) {
          _ProductListContents.push(response.data.listContent);
          toast.current.show({
            severity: "success",
            summary: "Successful",
            detail: "Our Product List Content Added",
            life: 3000,
          });
        } else {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: "Our Product List Content Not Added",
            life: 3000,
          });
        }
      }

      setProductListContents(_ProductListContents);
      setProductListContentsDialog(false);
      setProductListContent(emptyProductListContent);
    } catch (error) {
      console.error("Error during save operation:", error);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail:
          "An error occurred while saving the list content. Please try again later.",
        life: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  const editProduct = (ProductListContent) => {
    setProductListContent({ ...ProductListContent });
    setProductListContentsDialog(true);
  };

  const confirmDeleteProduct = (ProductListContent) => {
    setProductListContent(ProductListContent);
    setDeleteProductListContent(true);
  };
  const onProductChange = (selectedOption) => {
    const selectedProductId = selectedOption.value; // Assuming 'value' contains the selected category ID

    const selectedProduct = products.find(
      (product) => product.id === selectedProductId
    );
    setProductListContent({
      ...ProductListContent,
      product: { id: selectedOption.value, name: selectedProduct.name },
    });
  };

  const deleteProduct = async () => {
    setLoading(true);
    try {
      const response = await axios.delete(
        process.env.REACT_APP_BACKEND_URL +
          "api/ProductListContents/" +
          ProductListContent.id
      );

      setLoading(false);

      if (response.data.success) {
        let _ProductListContents = ProductListContents.filter(
          (val) => val.id !== ProductListContent.id
        );
        setProductListContents(_ProductListContents);
        setDeleteProductListContent(false);
        setProductListContent(emptyProductListContent);
        toast.current.show({
          severity: "success",
          summary: "Successful",
          detail: "Our Product List Content Deleted",
          life: 3000,
        });
      } else {
        throw new Error("Unexpected response");
      }
    } catch (error) {
      setLoading(false);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Our Product List Content Not Deleted",
        life: 3000,
      });
    }
  };

  const findIndexById = (id) => {
    let index = -1;

    for (let i = 0; i < ProductListContents.length; i++) {
      if (ProductListContents[i].id === id) {
        index = i;
        break;
      }
    }

    return index;
  };

  const createId = () => {
    let id = "";
    let chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (let i = 0; i < 5; i++) {
      id += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    return id;
  };

  const exportCSV = () => {
    dt.current.exportCSV();
  };

  const confirmDeleteSelected = () => {
    setDeleteProductListContentsDialog(true);
  };

  const deleteSelectedProducts = async () => {
    setLoading(true);
    const ids = selectedProductListContents.map(
      (ProductListContent) => ProductListContent.id
    );
    const idsString = ids.join(",");
    let data = { Ids: idsString };
    const response = await axios.post(
      process.env.REACT_APP_BACKEND_URL + "api/ProductListContents/DeleteByIds",
      data
    );
    setLoading(false);
    if (response.data.success) {
      let _ProductListContents = ProductListContents.filter(
        (val) => !selectedProductListContents.includes(val)
      );
      setProductListContents(_ProductListContents);
      setDeleteProductListContentsDialog(false);
      setSelectedProductListContents(null);
      toast.current.show({
        severity: "success",
        summary: "Successful",
        detail: "Our Product List Contents Deleted",
        life: 3000,
      });
    } else {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Our Product List Contents Not Deleted",
        life: 3000,
      });
    }
  };

  const onInputChange = (e, name) => {
    const val = (e.target && e.target.value) || "";
    let _ProductListContent = { ...ProductListContent };

    _ProductListContent[`${name}`] = val;

    setProductListContent(_ProductListContent);
  };
  const leftToolbarTemplate = () => {
    return (
      <div className="d-flex align-items-center justify-content-center gap-5">
        <h4 className="m-0 title-of-table">Manage Product List Content</h4>
        <span className="p-input-icon-left">
          <i className="pi pi-search" />
          <InputText
            type="search"
            style={{ border: "1px solid black" }}
            onInput={(e) => setGlobalFilter(e.target.value)}
            placeholder="Search..."
          />
        </span>
      </div>
    );
  };

  const rightToolbarTemplate = () => {
    return (
      <div className="d-flex flex-wrap gap-2">
        <Button
          label="New"
          icon="pi pi-plus"
          severity="success"
          onClick={openNew}
        />
        <Button
          label="Export"
          icon="pi pi-upload"
          className="p-button-help"
          onClick={exportCSV}
        />
        <Button
          label="Delete"
          icon="pi pi-trash"
          severity="danger"
          onClick={confirmDeleteSelected}
          disabled={
            !selectedProductListContents || !selectedProductListContents.length
          }
        />
      </div>
    );
  };
  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-pencil"
          rounded
          outlined
          style={{ marginRight: "10px" }}
          onClick={() => editProduct(rowData)}
        />
        <Button
          icon="pi pi-trash"
          rounded
          outlined
          severity="danger"
          onClick={() => confirmDeleteProduct(rowData)}
        />
      </React.Fragment>
    );
  };
  const header = (
    <div className="d-flex flex-wrap gap-2 align-items-center justify-content-between">
      {/* <h4 className="m-0">Manage Product Icons</h4>
      <span className="p-input-icon-left">
        <i className="pi pi-search" />
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
        />
      </span> */}
    </div>
  );
  const productDialogFooter = (
    <React.Fragment>
      <Button
        label="Cancel"
        icon="pi pi-times"
        outlined
        style={{ borderRadius: "10px" }}
        onClick={hideDialog}
      />
      <Button
        label="Save"
        loading={loading}
        style={{ borderRadius: "10px" }}
        icon="pi pi-check"
        onClick={saveService}
      />
    </React.Fragment>
  );
  const deleteProductDialogFooter = (
    <React.Fragment>
      <Button
        label="No"
        icon="pi pi-times"
        outlined
        onClick={hideDeleteProductDialog}
      />
      <Button
        label="Yes"
        loading={loading}
        icon="pi pi-check"
        severity="danger"
        onClick={deleteProduct}
      />
    </React.Fragment>
  );
  const deleteProductsDialogFooter = (
    <React.Fragment>
      <Button
        label="No"
        icon="pi pi-times"
        outlined
        onClick={hideDeleteProductsDialog}
      />
      <Button
        label="Yes"
        loading={loading}
        icon="pi pi-check"
        severity="danger"
        onClick={deleteSelectedProducts}
      />
    </React.Fragment>
  );
  function truncateHtml(html, maxLength) {
    const div = document.createElement("div");
    div.innerHTML = html;
    const text = div.textContent || div.innerText || "";
    const truncatedText =
      text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
    return truncatedText;
  }

  return (
    <div className="col-12 d-flex">
      <div className="col-3">
        <DashSideBar />
      </div>
      <div className="col-9">
        <div className="ProductListContent-container">
          <Toast ref={toast} />
          <div className="card">
            <Toolbar
              className="mb-3"
              start={leftToolbarTemplate}
              end={rightToolbarTemplate}
            ></Toolbar>

            <DataTable
              ref={dt}
              value={ProductListContents}
              selection={selectedProductListContents}
              onSelectionChange={(e) => setSelectedProductListContents(e.value)}
              dataKey="id"
              paginator
              rows={10}
              rowsPerPageOptions={[5, 10, 25]}
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Product Icons"
              globalFilter={globalFilter}
              header={header}
            >
              <Column selectionMode="multiple" exportable={false}></Column>
              <Column
                field="id"
                header="Code"
                sortable
                width="150px"
                style={{ textAlign: "center" }}
              ></Column>

              <Column
                field="description"
                header="Description"
                sortable
                style={{ minWidth: "12rem" }}
                body={(rowData) => (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: truncateHtml(rowData.description, 50),
                    }}
                  />
                )}
              ></Column>

              <Column
                field="product.name"
                header="Product"
                sortable
                style={{ minWidth: "12rem" }}
              ></Column>

              <Column
                field="sortOrder"
                header="Order"
                sortable
                style={{ textAlign: "center" }}
              ></Column>

              <Column
                body={actionBodyTemplate}
                exportable={false}
                style={{ minWidth: "12rem" }}
              ></Column>
            </DataTable>
          </div>

          <Dialog
            visible={ProductListContentsDialog}
            style={{ width: "32rem" }}
            breakpoints={{ "960px": "75vw", "641px": "90vw" }}
            header="ProductListContent Details"
            modal
            className="p-fluid"
            footer={productDialogFooter}
            onHide={hideDialog}
          >
            <div className="field">
              <label htmlFor="description" className="font-bold mb-1">
                Description :
              </label>
              <Editor
                id="description"
                value={ProductListContent.description ?? ""}
                style={{ height: "100px" }}
                onTextChange={(e) =>
                  onInputChange(
                    { target: { value: e.htmlValue } },
                    "description"
                  )
                }
                required
                className={classNames({
                  "p-invalid": submitted && !ProductListContent.description,
                })}
              />
            </div>
            <div className="field">
              <label className="mb-3 font-bold">Product</label>
              {products != null ? (
                <Dropdown
                  value={ProductListContent.product.id}
                  options={products.map((product) => ({
                    value: product.id,
                    label: product.name,
                  }))}
                  onChange={onProductChange}
                  placeholder="Select a Product"
                />
              ) : (
                <p>Loading products...</p>
              )}
            </div>
            <div className="field">
              <label htmlFor="sortOrder" className="font-bold mt-3 mb-1">
                Order :
              </label>
              <InputText
                id="sortOrder"
                type="number"
                value={ProductListContent.sortOrder ?? 1}
                onChange={(e) => onInputChange(e, "sortOrder")}
                required
                className={classNames({
                  "p-invalid": submitted && !ProductListContent.sortOrder,
                })}
              />
              {submitted && !ProductListContent.sortOrder && (
                <small className="p-error">Sort Order is required.</small>
              )}
            </div>
          </Dialog>

          <Dialog
            visible={DeleteProductListContent}
            style={{ width: "32rem" }}
            breakpoints={{ "960px": "75vw", "641px": "90vw" }}
            header="Confirm"
            modal
            footer={deleteProductDialogFooter}
            onHide={hideDeleteProductDialog}
          >
            <div className="confirmation-content">
              <i
                className="pi pi-exclamation-triangle mr-3"
                style={{
                  textAlign: "center",
                  fontSize: "2rem",
                  width: "100%",
                  color: "#6659ff",
                }}
              />
              <div>
                <p style={{ textAlign: "center", marginBottom: "5px" }}>
                  Are you sure you want to delete:
                </p>
                {ProductListContent && (
                  <p style={{ textAlign: "center", marginBottom: "0" }}>
                    <b>{ProductListContent.title}</b>
                  </p>
                )}
              </div>
            </div>
          </Dialog>

          <Dialog
            visible={DeleteProductListContentsDialog}
            style={{ width: "32rem" }}
            breakpoints={{ "960px": "75vw", "641px": "90vw" }}
            header="Confirm"
            modal
            footer={deleteProductsDialogFooter}
            onHide={hideDeleteProductsDialog}
          >
            <div className="confirmation-content">
              <i
                className="pi pi-exclamation-triangle mr-3"
                style={{
                  textAlign: "center",
                  fontSize: "2rem",
                  width: "100%",
                  color: "#6659ff",
                }}
              />
              {ProductListContent && (
                <p
                  style={{
                    textAlign: "center",
                    marginTop: "10px",
                    marginBottom: "25px",
                  }}
                >
                  Are you sure you want to delete the selected Product List
                  Contents?
                </p>
              )}
            </div>
          </Dialog>
        </div>
      </div>
    </div>
  );
}

export default ProductListContents;
